module.exports = __webpack_public_path__ + "media/errors/404-career-planning-de32894f.png";